import { createInstance } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translations from './translations';
import SyfStorage from '../../helpers/SyfStorage';
var alertsI18n = createInstance({
    fallbackLng: 'en',
    lng: SyfStorage.getLanguage(),
    interpolation: {
        escapeValue: false // not needed for react as it escapes by default
    },
    resources: translations,
    parseMissingKeyHandler: function () { return ''; }
});
alertsI18n.use(LanguageDetector).use(initReactI18next).init();
export default alertsI18n;
